import React from 'react';
import styled from 'styled-components';

import { Row, Col } from './Grid';

const TextArea = styled.textarea`
  font-family: monospace;
  margin-top: 1em;
  min-height: 250px;
  width: 100%;
`;

const StructureInput = (props) => {
  return (
    <form>
      <h1>Structure</h1>
      <Row>
        <Col>
          <strong>Assertion Type:</strong>
        </Col>
        <Col>
          <input
            type="radio"
            onChange={props.typeOnChange}
            name="matchType"
            value="contain"
            checked={props.typeVal === 'contain'}
            id="contain"
          /><label htmlFor="contain">Contain</label>
        </Col>
        <Col>
          <input
            type="radio"
            onChange={props.typeOnChange}
            name="matchType"
            value="doesNotContain"
            checked={props.typeVal === 'doesNotContain'}
            id="doesNotContain"
          /><label htmlFor="doesNotContain">Not Contain</label>
        </Col>
        <Col>
          <input
            type="radio"
            onChange={props.typeOnChange}
            name="matchType"
            value="match"
            checked={props.typeVal === 'match'}
            id="match"
          /><label htmlFor="match">Match</label>
        </Col>
      </Row>
      <TextArea onChange={props.structureOnChange} value={props.structureVal} />
    </form>
  );
};

export default StructureInput;



// WEBPACK FOOTER //
// ./src/StructureInput.js